import type { ImageSourcePropType } from 'react-native';

/**
 * Kolobok «HD dark skin» set, copied from local archive provided by user.
 */

/** Basenames without `.gif`, matching files under {@link DARK_SKIN_BASE}. */
export const DARK_SKIN_STEMS = [
  'acute',
  'aggressive',
  'air_kiss',
  'angel',
  'bad',
  'bb',
  'beach',
  'beee',
  'big_boss',
  'biggrin',
  'blum2',
  'blush',
  'boast',
  'bomb',
  'boredom',
  'bye',
  'censored',
  'clapping',
  'cray',
  'crazy',
  'curtsey',
  'dance4',
  'dash1',
  'dirol',
  'drinks',
  'feminist',
  'flirt',
  'focus',
  'fool',
  'friends',
  'gamer4',
  'girl_cray2',
  'girl_crazy',
  'girl_drink4',
  'girl_haha',
  'girl_hospital',
  'girl_impossible',
  'girl_in_love',
  'girl_sigh',
  'give_heart2',
  'give_rose',
  'good',
  'heart',
  'help',
  'hi',
  'hunter',
  'hysteric',
  'i-m_so_happy',
  'ireful1',
  'king',
  'kiss2',
  'kiss3',
  'lazy',
  'lol',
  'mail1',
  'mamba',
  'mega_shock',
  'mocking',
  'moil',
  'music',
  'nea',
  'new_russian',
  'ok',
  'paint2',
  'pardon',
  'party2',
  'pleasantry',
  'popcorn1',
  'prankster2',
  'preved',
  'punish',
  'rofl',
  'sad',
  'sarcastic',
  'scare',
  'scratch_one-s_head',
  'search',
  'secret',
  'shock',
  'shout',
  'slow',
  'smile',
  'smoke',
  'sorry2',
  'spiteful',
  'spruce_up',
  'stop',
  'tease',
  'tender',
  'thank_you2',
  'this',
  'training1',
  'unknown',
  'vampire',
  'vava',
  'victory',
  'wacko2',
  'wink',
  'wizard',
  'yahoo',
  'yes3',
  'yess',
] as const;

export const DARK_SKIN_STEM_SET: ReadonlySet<string> = new Set(DARK_SKIN_STEMS);

const DARK_SKIN_SOURCE_BY_STEM: Record<string, ImageSourcePropType> = {
  'acute': require('../../assets/emoji/hd_dark_skin/acute.gif'),
  'aggressive': require('../../assets/emoji/hd_dark_skin/aggressive.gif'),
  'air_kiss': require('../../assets/emoji/hd_dark_skin/air_kiss.gif'),
  'angel': require('../../assets/emoji/hd_dark_skin/angel.gif'),
  'bad': require('../../assets/emoji/hd_dark_skin/bad.gif'),
  'bb': require('../../assets/emoji/hd_dark_skin/bb.gif'),
  'beach': require('../../assets/emoji/hd_dark_skin/beach.gif'),
  'beee': require('../../assets/emoji/hd_dark_skin/beee.gif'),
  'big_boss': require('../../assets/emoji/hd_dark_skin/big_boss.gif'),
  'biggrin': require('../../assets/emoji/hd_dark_skin/biggrin.gif'),
  'blum2': require('../../assets/emoji/hd_dark_skin/blum2.gif'),
  'blush': require('../../assets/emoji/hd_dark_skin/blush.gif'),
  'boast': require('../../assets/emoji/hd_dark_skin/boast.gif'),
  'bomb': require('../../assets/emoji/hd_dark_skin/bomb.gif'),
  'boredom': require('../../assets/emoji/hd_dark_skin/boredom.gif'),
  'bye': require('../../assets/emoji/hd_dark_skin/bye.gif'),
  'censored': require('../../assets/emoji/hd_dark_skin/censored.gif'),
  'clapping': require('../../assets/emoji/hd_dark_skin/clapping.gif'),
  'cray': require('../../assets/emoji/hd_dark_skin/cray.gif'),
  'crazy': require('../../assets/emoji/hd_dark_skin/crazy.gif'),
  'curtsey': require('../../assets/emoji/hd_dark_skin/curtsey.gif'),
  'dance4': require('../../assets/emoji/hd_dark_skin/dance4.gif'),
  'dash1': require('../../assets/emoji/hd_dark_skin/dash1.gif'),
  'dirol': require('../../assets/emoji/hd_dark_skin/dirol.gif'),
  'drinks': require('../../assets/emoji/hd_dark_skin/drinks.gif'),
  'feminist': require('../../assets/emoji/hd_dark_skin/feminist.gif'),
  'flirt': require('../../assets/emoji/hd_dark_skin/flirt.gif'),
  'focus': require('../../assets/emoji/hd_dark_skin/focus.gif'),
  'fool': require('../../assets/emoji/hd_dark_skin/fool.gif'),
  'friends': require('../../assets/emoji/hd_dark_skin/friends.gif'),
  'gamer4': require('../../assets/emoji/hd_dark_skin/gamer4.gif'),
  'girl_cray2': require('../../assets/emoji/hd_dark_skin/girl_cray2.gif'),
  'girl_crazy': require('../../assets/emoji/hd_dark_skin/girl_crazy.gif'),
  'girl_drink4': require('../../assets/emoji/hd_dark_skin/girl_drink4.gif'),
  'girl_haha': require('../../assets/emoji/hd_dark_skin/girl_haha.gif'),
  'girl_hospital': require('../../assets/emoji/hd_dark_skin/girl_hospital.gif'),
  'girl_impossible': require('../../assets/emoji/hd_dark_skin/girl_impossible.gif'),
  'girl_in_love': require('../../assets/emoji/hd_dark_skin/girl_in_love.gif'),
  'girl_sigh': require('../../assets/emoji/hd_dark_skin/girl_sigh.gif'),
  'give_heart2': require('../../assets/emoji/hd_dark_skin/give_heart2.gif'),
  'give_rose': require('../../assets/emoji/hd_dark_skin/give_rose.gif'),
  'good': require('../../assets/emoji/hd_dark_skin/good.gif'),
  'heart': require('../../assets/emoji/hd_dark_skin/heart.gif'),
  'help': require('../../assets/emoji/hd_dark_skin/help.gif'),
  'hi': require('../../assets/emoji/hd_dark_skin/hi.gif'),
  'hunter': require('../../assets/emoji/hd_dark_skin/hunter.gif'),
  'hysteric': require('../../assets/emoji/hd_dark_skin/hysteric.gif'),
  'i-m_so_happy': require('../../assets/emoji/hd_dark_skin/i-m_so_happy.gif'),
  'ireful1': require('../../assets/emoji/hd_dark_skin/ireful1.gif'),
  'king': require('../../assets/emoji/hd_dark_skin/king.gif'),
  'kiss2': require('../../assets/emoji/hd_dark_skin/kiss2.gif'),
  'kiss3': require('../../assets/emoji/hd_dark_skin/kiss3.gif'),
  'lazy': require('../../assets/emoji/hd_dark_skin/lazy.gif'),
  'lol': require('../../assets/emoji/hd_dark_skin/lol.gif'),
  'mail1': require('../../assets/emoji/hd_dark_skin/mail1.gif'),
  'mamba': require('../../assets/emoji/hd_dark_skin/mamba.gif'),
  'mega_shock': require('../../assets/emoji/hd_dark_skin/mega_shock.gif'),
  'mocking': require('../../assets/emoji/hd_dark_skin/mocking.gif'),
  'moil': require('../../assets/emoji/hd_dark_skin/moil.gif'),
  'music': require('../../assets/emoji/hd_dark_skin/music.gif'),
  'nea': require('../../assets/emoji/hd_dark_skin/nea.gif'),
  'new_russian': require('../../assets/emoji/hd_dark_skin/new_russian.gif'),
  'ok': require('../../assets/emoji/hd_dark_skin/ok.gif'),
  'paint2': require('../../assets/emoji/hd_dark_skin/paint2.gif'),
  'pardon': require('../../assets/emoji/hd_dark_skin/pardon.gif'),
  'party2': require('../../assets/emoji/hd_dark_skin/party2.gif'),
  'pleasantry': require('../../assets/emoji/hd_dark_skin/pleasantry.gif'),
  'popcorn1': require('../../assets/emoji/hd_dark_skin/popcorn1.gif'),
  'prankster2': require('../../assets/emoji/hd_dark_skin/prankster2.gif'),
  'preved': require('../../assets/emoji/hd_dark_skin/preved.gif'),
  'punish': require('../../assets/emoji/hd_dark_skin/punish.gif'),
  'rofl': require('../../assets/emoji/hd_dark_skin/rofl.gif'),
  'sad': require('../../assets/emoji/hd_dark_skin/sad.gif'),
  'sarcastic': require('../../assets/emoji/hd_dark_skin/sarcastic.gif'),
  'scare': require('../../assets/emoji/hd_dark_skin/scare.gif'),
  'scratch_one-s_head': require('../../assets/emoji/hd_dark_skin/scratch_one-s_head.gif'),
  'search': require('../../assets/emoji/hd_dark_skin/search.gif'),
  'secret': require('../../assets/emoji/hd_dark_skin/secret.gif'),
  'shock': require('../../assets/emoji/hd_dark_skin/shock.gif'),
  'shout': require('../../assets/emoji/hd_dark_skin/shout.gif'),
  'slow': require('../../assets/emoji/hd_dark_skin/slow.gif'),
  'smile': require('../../assets/emoji/hd_dark_skin/smile.gif'),
  'smoke': require('../../assets/emoji/hd_dark_skin/smoke.gif'),
  'sorry2': require('../../assets/emoji/hd_dark_skin/sorry2.gif'),
  'spiteful': require('../../assets/emoji/hd_dark_skin/spiteful.gif'),
  'spruce_up': require('../../assets/emoji/hd_dark_skin/spruce_up.gif'),
  'stop': require('../../assets/emoji/hd_dark_skin/stop.gif'),
  'tease': require('../../assets/emoji/hd_dark_skin/tease.gif'),
  'tender': require('../../assets/emoji/hd_dark_skin/tender.gif'),
  'thank_you2': require('../../assets/emoji/hd_dark_skin/thank_you2.gif'),
  'this': require('../../assets/emoji/hd_dark_skin/this.gif'),
  'training1': require('../../assets/emoji/hd_dark_skin/training1.gif'),
  'unknown': require('../../assets/emoji/hd_dark_skin/unknown.gif'),
  'vampire': require('../../assets/emoji/hd_dark_skin/vampire.gif'),
  'vava': require('../../assets/emoji/hd_dark_skin/vava.gif'),
  'victory': require('../../assets/emoji/hd_dark_skin/victory.gif'),
  'wacko2': require('../../assets/emoji/hd_dark_skin/wacko2.gif'),
  'wink': require('../../assets/emoji/hd_dark_skin/wink.gif'),
  'wizard': require('../../assets/emoji/hd_dark_skin/wizard.gif'),
  'yahoo': require('../../assets/emoji/hd_dark_skin/yahoo.gif'),
  'yes3': require('../../assets/emoji/hd_dark_skin/yes3.gif'),
  'yess': require('../../assets/emoji/hd_dark_skin/yess.gif'),
};

export function darkSkinGifSource(stem: string): ImageSourcePropType | null {
  return DARK_SKIN_SOURCE_BY_STEM[stem] ?? null;
}

/** Inserts into outgoing chat text; rendered as inline GIF when stem is known. */
export function encodeDarkSkinMarker(stem: string): string {
  return `[[hds:${stem}]]`;
}
